import { render } from "./ModuleCard.vue?vue&type=template&id=c615e744&scoped=true"
import script from "./ModuleCard.vue?vue&type=script&lang=js"
export * from "./ModuleCard.vue?vue&type=script&lang=js"

import "./ModuleCard.vue?vue&type=style&index=0&id=c615e744&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c615e744"]])

export default __exports__